import jwtDecode from 'jwt-decode';
import { sitePromoUouView, sitePromoUouCtaClick } from '@wix/bi-logger-wixlabs-ugc/v2';
import { sitePromoButtonClick, sitePromoElementLoaded, sitePromoPromoCreated, sitePromoPromoEdited, sitePromoStatusChanged, sitePromoPromoPublished } from '@wix/bi-logger-wixlabs-users/v2';
import { INSTANCE_KEYS } from '../enums';
const BI_FUNCS = {
  buttonClick: sitePromoButtonClick,
  elementLoaded: sitePromoElementLoaded,
  promoCreated: sitePromoPromoCreated,
  promoEdited: sitePromoPromoEdited,
  statusChanged: sitePromoStatusChanged,
  promoPublished: sitePromoPromoPublished,
  uouView: sitePromoUouView,
  uouCtaClick: sitePromoUouCtaClick
};
export const baseParamsBuilder = instance => ({
  uuid: getDataFromInstance(instance, INSTANCE_KEYS.UID),
  msid: getDataFromInstance(instance, INSTANCE_KEYS.META_SITE_ID),
  instance_id: getDataFromInstance(instance, INSTANCE_KEYS.INSTANCE_ID)
});
export const getDataFromInstance = (instance, type) => {
  const decoded = instance ? jwtDecode(instance) : null;
  return (decoded == null ? void 0 : decoded[type]) || null;
};
export const getBiEventFunction = function (biType) {
  if (biType === void 0) {
    biType = 'buttonClick';
  }
  return BI_FUNCS[biType] || sitePromoButtonClick;
};
//# sourceMappingURL=bi.js.map